import React, { useEffect, useState } from 'react';

//usado para exportar conexión de websocket.
export function useWebSocket({
	websocketUrl,
	onMessage,
	onOpen,
	onClose,
	onError
}) {
	useEffect(() => {
		const ws = new WebSocket(websocketUrl);
		ws.onmessage = onMessage;
		ws.onopen = onOpen;
		ws.onclose = onClose;
		ws.onerror = onError;
	}, []);
}
